/**
 * Lilja product image lightbox (PhotoSwipe 5).
 * Opens from a.lilja-lightbox-trigger inside [data-lilja-lightbox-gallery].
 * Core module is loaded only on first open.
 */
import PhotoSwipeLightbox from './photoswipe-lightbox.esm.js';

const GALLERY_SELECTOR = '[data-lilja-lightbox-gallery]';

/**
 * @param {HTMLElement} galleryEl
 */
function initGallery(galleryEl) {
  if (galleryEl.dataset.liljaLightboxReady === 'true') return;
  galleryEl.dataset.liljaLightboxReady = 'true';

  const zoomHint = galleryEl.dataset.zoomHint || '';

  const lightbox = new PhotoSwipeLightbox({
    gallery: galleryEl,
    children: 'a.lilja-lightbox-trigger',
    pswpModule: () => import('./photoswipe.esm.js'),
    bgOpacity: 0.92,
    wheelToZoom: true,
    paddingFn: (viewportSize) => ({
      top: Math.min(40, Math.round(viewportSize.y * 0.04)),
      bottom: Math.min(40, Math.round(viewportSize.y * 0.04)),
      left: Math.min(24, Math.round(viewportSize.x * 0.04)),
      right: Math.min(24, Math.round(viewportSize.x * 0.04)),
    }),
  });

  if (zoomHint) {
    lightbox.on('uiRegister', () => {
      lightbox.pswp.ui.registerElement({
        name: 'liljaZoomHint',
        order: 9,
        isButton: false,
        appendTo: 'wrapper',
        html: zoomHint,
        onInit: (el, pswp) => {
          el.className = 'lilja-lightbox-zoom-hint';
          el.setAttribute('aria-hidden', 'true');

          const hide = () => el.classList.add('is-hidden');
          const hideTimer = window.setTimeout(hide, 2800);

          pswp.on('pointerDown', () => {
            window.clearTimeout(hideTimer);
            hide();
          });
          pswp.on('close', () => window.clearTimeout(hideTimer));
        },
      });
    });
  }

  lightbox.init();
}

function initAll() {
  document.querySelectorAll(GALLERY_SELECTOR).forEach(initGallery);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}

document.addEventListener('shopify:section:load', initAll);
